import { type IconKind, type MenuMultiOption } from '@saviynt/design-system';

import { type ServiceIdentityFilters } from '../types';

// Common
export const INPUT_CHAR_LIMIT = 3;
export const MAX_CHIP_LENGTH = 255;
export const VALID_CHIP_PATTERN = /^[a-z0-9_:-]+$/;

// Search, Filters, and Sort
export const CHAR_LIMIT_FOR_SEARCH = 2;
export const F_KEY_NM = 'name';
export const F_KEY_ST = 'status';
export const F_KEY_ON = 'owner';
export const F_KEY_TG = 'tags';
export const F_KEY_SA = 'serviceAccounts';
export const F_KEY_AP = 'application';

export const FILTERS_CONFIG: ServiceIdentityFilters[] = [
  {
    label: 'label.name',
    value: F_KEY_NM,
    isApiBased: true,
    options: [] as MenuMultiOption[],
  },
  {
    label: 'label.status',
    value: F_KEY_ST,
    isApiBased: false,
    options: [
      {
        label: 'status.enabled',
        value: 'active',
      },
      {
        label: 'status.disabled',
        value: 'inactive',
      },
      {
        label: 'status.deleted',
        value: 'deleted',
      },
    ],
  },
  {
    label: 'label.owners',
    value: F_KEY_ON,
    isApiBased: true,
    options: [] as MenuMultiOption[],
  },
];

// Lists
export const LEAVE_ANIM_DURATION = 600;
export const LIST_MAX_COUNT = 25;
export const LIST_SORT_OPTIONS = [
  {
    label: 'sort.label.ascending',
    value: 'asc',
    icon: 'ArrowUp' as IconKind,
    isDisabled: false,
    isChecked: false,
    shouldShowCheckIcon: true,
  },
  {
    label: 'sort.label.descending',
    value: 'desc',
    icon: 'ArrowDown' as IconKind,
    isDisabled: false,
    isChecked: false,
    shouldShowCheckIcon: true,
  },
];

export const LIST_COLUMNS: {
  label: string;
  value: string;
  isSortField: boolean;
  isChecked: boolean;
}[] = [
  {
    label: 'sort.label.name',
    value: F_KEY_NM,
    isSortField: true,
    isChecked: true,
  },
  {
    label: 'sort.label.status',
    value: F_KEY_ST,
    isSortField: true,
    isChecked: true,
  },
  {
    label: 'sort.label.owners',
    value: F_KEY_ON,
    isSortField: false,
    isChecked: true,
  },
  {
    label: 'sort.label.tags',
    value: F_KEY_TG,
    isSortField: false,
    isChecked: true,
  },
  {
    label: 'sort.label.service.accounts',
    value: F_KEY_SA,
    isSortField: false,
    isChecked: true,
  },
];

// Actions
export const A_KEY_RO = 'rotate';
export const A_KEY_OS = 'ownership';
export const A_KEY_DS = 'disable';
export const A_KEY_EN = 'enable';
export const A_KEY_DT = 'delete';
export const A_KEY_SA = 'service-account';
export const A_KEY_SA_UN = 'service-account-unlink';
export const SERVICE_IDENTITY_ROTATE_ACTION = {
  label: 'action.rotate.credentials',
  value: A_KEY_RO,
  icon: 'Reset',
};
export const SERVICE_IDENTITY_OWNER_ACTION = {
  label: 'action.manage.owners',
  value: A_KEY_OS,
  icon: 'User',
};
export const SERVICE_IDENTITY_DISABLE_ACTION = {
  label: 'action.disable',
  value: A_KEY_DS,
  icon: 'Reject',
};
export const SERVICE_IDENTITY_ENABLE_ACTION = {
  label: 'action.enable',
  value: A_KEY_EN,
  icon: 'RequestApproval',
};
export const SERVICE_IDENTITY_DELETE_ACTION = {
  label: 'action.delete',
  value: A_KEY_DT,
  icon: 'Delete',
};

// Sidepanel
export const SIDEPANEL_ANIMATION_DURATION = 200;
export const SIDEPANEL_OWNERS_COUNT_TO_SHOW = 4;
